import { render, staticRenderFns } from "./CardCert.vue?vue&type=template&id=9b14de84&scoped=true&"
import script from "./CardCert.vue?vue&type=script&lang=js&"
export * from "./CardCert.vue?vue&type=script&lang=js&"
import style0 from "./CardCert.vue?vue&type=style&index=0&id=9b14de84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b14de84",
  null
  
)

export default component.exports